import { useSelector } from "react-redux";
import { handleSaveProject } from "../../helpers/saveProject";

const KlausurSaveButton = () => {
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const schueler = useSelector((st) => st.schueler);
  const companies = useSelector((st) => st.companies);

  return (
    <button
      className="btn btn-outline-dark"
      onClick={() => handleSaveProject(currentKlausur, companies, schueler)}
    >
      Klausur in Projektdatei speichern
    </button>
  );
};
export default KlausurSaveButton;
